<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Add Notes to {{ item.name }}</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    class="dialog-close-button"
    mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="px-3 py-4">
  <form #f="ngForm">
    <mat-form-field class="full-width mb-0" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Item Notes</mat-label>
        <textarea
          matInput
          required
          name="notes"
          cols="50"
          rows="10"
          [(ngModel)]="item.pivot.notes"
          placeholder="Item Notes">
        </textarea>
    </mat-form-field>
  </form>
</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="px-3 py-2">
  <button
    class="my-2 ml-1 mr-2"
    mat-raised-button
    color="primary"
    [disabled]="!f.valid"
    (click)="onSaveAndClose()">
    <mat-icon>save</mat-icon> Save
  </button>
</mat-dialog-actions>
